import metaModel from '~/shared/src/utilities/metaModel';
import Reference, {
    ReferenceAttributesForCreation
} from '~/shared/src/ci/Reference';
import ciHelper from '~/shared/src/utilities/dataUtils';

import {DATA_ADD_REFERENCE} from '~/frontend/src/constants';
import {
    AppDispatch,
    StoreState,
    Thunk
} from '~/frontend/src/store';
import {setElusiveData} from '~/frontend/src/actions/elusiveData';


/**
 * @memberOf! Actions
 *
 * @param {String} dataContext
 * @param {Reference|ReferenceAttributesForCreation} reference
 * @param {Schema} schema
 * @param {string[]} [additionalElusiveDataContexts=[]]
 *
 * @return {void}
 */
const addReference = ( dataContext : string, reference : Reference | ReferenceAttributesForCreation, schema : Schema | undefined = undefined, additionalElusiveDataContexts : string[] = [] ) : Thunk<Reference> => ( dispatch : AppDispatch, getState : () => StoreState ) : Reference => {
    schema = schema ?? global.data[ dataContext ]?.schema ?? global.schema;

    dispatch( {
        type     : DATA_ADD_REFERENCE,
        dataContext,
        reference: reference instanceof Reference ? reference.toJSON() : reference,
        schema,
        additionalElusiveDataContexts
    } );

    if ( reference ) {
        let isNewReference = false;

        // if reference is given as ReferenceAttributes object here, check for existing one or create the new Reference
        if ( !( reference instanceof Reference ) ) {
            const existingReference = ciHelper.findReference( dataContext, reference.referenceSetId, reference.srcItemId, reference.destItemId );

            if ( existingReference ) {
                reference = existingReference;
            }
            else {
                isNewReference = true;
                reference = new Reference( reference, dataContext, schema );
            }
        }

        if ( !isNewReference && reference.isDeleted() ) {
            reference = reference.reset().clone();
            reference.statusId = metaModel[ schema ].getStatus( 'active' )!.id;
        }

        // update ElusiveData
        additionalElusiveDataContexts.unshift( dataContext );
        for ( const elusiveDataContext of additionalElusiveDataContexts ) {
            const elusiveData    = getState().elusiveData?.[ elusiveDataContext ],
                  newElusiveData = {
                      ...elusiveData,
                      data: {
                          ...elusiveData?.data,
                          items     : {
                              ...elusiveData?.data?.items,
                              [ reference.srcItemId ] : ( elusiveData?.data?.items?.[ reference.srcItemId ] ?? 0 ) + 1,
                              [ reference.destItemId ]: ( elusiveData?.data?.items?.[ reference.destItemId ] ?? 0 ) + 1
                          },
                          references: {
                              ...elusiveData?.data?.references,
                              [ reference.id ]: ( elusiveData?.data?.references?.[ reference.id ] ?? 0 ) + 1
                          }
                      }
                  };

            dispatch( setElusiveData( elusiveDataContext, newElusiveData ) );
        }
    }

    return reference;
}
export type AddReference = typeof addReference;

export default addReference;
